import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgIconWhale = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 23,
	height: 19,
	viewBox: "0 0 23 19",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M7.54918 17.1887C6.84725 17.474 6.14117 17.7432 5.39008 17.8745C3.95911 18.1249 2.55707 17.9898 1.17571 17.5649C1.13314 17.5492 1.09156 17.531 1.05122 17.5102C1.10404 17.4331 1.18903 17.4276 1.25564 17.4C2.40834 16.9359 3.46361 16.2595 4.36658 15.4058C4.49475 15.2859 4.48786 15.2308 4.36336 15.1104C1.98009 12.8103 0.855059 9.99842 1.01492 6.69316C1.1068 4.81337 1.69711 3.08196 2.72704 1.50214C2.76609 1.44242 2.78493 1.35376 2.88369 1.35422C2.99303 1.46217 2.92963 1.58391 2.9085 1.69967C2.67881 3.00019 2.94249 4.18034 3.78133 5.2089C4.95872 6.65549 6.90834 7.0841 8.59244 6.28523C9.37982 5.91175 10.0799 5.40919 10.7561 4.8685C11.6703 4.13762 12.5877 3.41133 13.5584 2.75534C14.8267 1.90088 16.2104 1.33125 17.7286 1.11442C18.471 1.0083 19.2175 0.95915 19.9672 1.04092C20.0591 1.05103 20.151 1.05654 20.2079 1.1475C20.218 1.29082 20.0958 1.29634 20.0095 1.32252C19.6352 1.43505 19.2672 1.56739 18.907 1.71897C17.3451 2.38507 16.1429 3.43614 15.3238 4.93465C14.6926 6.0877 14.2043 7.29955 13.7389 8.52334C13.1536 10.0627 12.5225 11.5824 11.7727 13.0496C11.3437 13.8903 10.8613 14.7034 10.1952 15.3805C9.50086 16.0859 8.69619 16.6733 7.81287 17.1198C7.73018 17.168 7.6383 17.1708 7.54918 17.1887Z",
			fill: "white",
			stroke: "#193A97",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.54919 17.1886C7.58479 17.1604 7.62241 17.1349 7.66174 17.1123C9.47493 16.2253 10.7961 14.8586 11.6901 13.0514C12.5082 11.3976 13.2184 9.69789 13.8689 7.97199C14.2417 6.98413 14.6712 6.01859 15.1552 5.08017C16.209 3.035 17.9147 1.83877 20.0825 1.22595C20.1335 1.21171 20.1818 1.18966 20.2314 1.17129C20.2527 1.15228 20.2805 1.14228 20.3091 1.14339C20.3376 1.14451 20.3646 1.15665 20.3843 1.17726C21.2525 2.42055 21.851 3.83166 22.1415 5.31997C23.2284 10.8785 19.7031 16.37 14.1776 17.7077C13.4886 17.8749 12.7875 17.9916 12.0727 17.9874C11.7971 17.9853 11.5215 17.9853 11.2458 17.9874C10.1263 17.9723 9.04954 17.7366 7.99939 17.3618C7.8455 17.308 7.69849 17.2465 7.54919 17.1886Z",
			fill: "white",
			stroke: "#193A97",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.153 7.33626C11.153 7.01929 11.3827 6.77168 11.6661 6.77444C11.9496 6.77719 12.1714 7.03215 12.1673 7.34867C12.1632 7.66518 11.9321 7.91922 11.6537 7.91508C11.3753 7.91095 11.1498 7.6491 11.153 7.33626Z",
			fill: "#193A97",
			stroke: "#193A97",
			strokeWidth: .6,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgIconWhale;
